import { Page } from "@/models/page-models/Page";

export const PaymentCollectionReceipts: Page = {
  "path": "payment-collection-receipts",
  "name": "Payment Collection Receipts",
  "props": {
    "data": {
      "title": "Payment Collection Receipts",
      "printable": "FALSE",
      "url": "payment-collection-receipts",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create Invoice Payment",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "openInvoicePaymentPage"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "table",
                  "label": "My Invoice Payments",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.invoicePayments.data}}",
                  "items": "fetchedData.invoicePayments.data",
                  "headers": [
                    {
                      "value": "_id",
                      "text": "Payment Id",
                      "type": "url",
                      "url": "/invoice-payment-receipt/{{__item._id}}"
                    },
                    {
                      "value": "customer.alias",
                      "text": "Customer",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                    },
                    {
                      "value": "createdBy.displayName",
                      "text": "Created By"
                    },
                    {
                      "value": "status",
                      "text": "Status"
                    },
                    {
                      "value": "amountReceived",
                      "text": "Amount",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,{{{{__item.amountReceived}} || {{__item.expectedAmountReceived}}}})"
                    },
                    {
                      "value": "updatedAt",
                      "text": "Last Updated",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                    }
                  ],
                  "tableType": "static",
                  "selectableUniqueId": "_id",
                  "groupActions": [
                    {
                      "label": "Edit",
                      "disableIf": "fn(LOGICAL,fn(SUM,fn(LOGICAL,fn(LENGTH,{{__item}}),>,1),fn(LOGICAL,fn(CONCAT,',{{__item.0.status}},'),!==,'Submitted')),!==,0)",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "openEditPaymentCollection",
                            "type": "fnRedirect",
                            "arg1Key": "redirectUrl",
                            "arg1Value": "update-payment-collection",
                            "arg2Key": "queryParams",
                            "arg2Value": "{\"receipt\":\"{{__item._id}}\"}"
                          },
                          "name": "openEditPaymentCollection"
                        }
                      ]
                    }
                  ],
                  "neverHideActionBar": true
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getInvoicePayments"
      }
    ],
    "functions": [
      {
        "name": "getInvoicePayments",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "fn(CONDITIONAL,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)),/api/v2/invoice-payment-receipts,/api/v2/my-invoice-payment-receipts)",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.invoicePayments"
      },
      {
        "name": "approvePayment",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/invoice-payment-receipt/{{__item._id}}/approve",
        "arg2Key": "postData",
        "arg2Value": "\"{}\"",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "rejectPayment",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/invoice-payment-receipt/{{__item._id}}/reject",
        "arg2Key": "postData",
        "arg2Value": "\"{}\"",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "openInvoicePaymentPage",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/create-payment-collection-receipt"
      }
    ]
  },
  "forRole": "SALES_ACCOUNT_EXECUTIVE,SALES_MANAGER,GENERAL_MANAGER",
  "visible": false
}